import { NftDetailSection } from '../components'

const NftDetail = () => {
  return (
    <div><NftDetailSection/></div>
  )
}

export default NftDetail